import { UserAcceptCampaignProvider } from '../new-http/providers/user-accept-campaign.http.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UserAcceptCampaignService {
  constructor(private userAcceptCampaing: UserAcceptCampaignProvider) {}

  public getUserAcceptCampaing() {
    return this.userAcceptCampaing.get(`user-accept-campaign`);
  }

  public putUserAcceptCampaing(body) {
    return this.userAcceptCampaing.put(`user-accept-campaign`, body);
  }
}
